import dayjs from '@/plugins/dayjs';
import { getPlainDate } from '@mtntop/utils/shared/helpers/temporal';

const dateMixin = {
  methods: {
    dateOnlyView(date) {
      if (!date) {
        return '';
      }
      const plainDate = getPlainDate(date);
      const jsDate = new Date(plainDate.year, plainDate.month - 1, plainDate.day);
      jsDate.setHours(0, 0, 0, 0);
      return dayjs(jsDate).format('l');
    }
  },
  filters: {
    filteredDateTime(date) {
      if (!date) return '';
      let d = new Date(date);
      d = dayjs(new Date(d.getTime() + d.getTimezoneOffset() * 60000));
      return `${d.format('l')} ${d.format('LT')}`;
    },
    dateOnly(date) {
      if (!date) {
        return '';
      }
      const plainDate = getPlainDate(date);
      if (!plainDate) return '';

      const jsDate = new Date(plainDate.year, plainDate.month - 1, plainDate.day);
      jsDate.setHours(0, 0, 0, 0);
      return dayjs(jsDate).format('l');
    },
    dateAge(date) {
      if (!date) {
        return '';
      }
      const plainDate = getPlainDate(date);
      if (!plainDate) return '';

      const jsDate = new Date(plainDate.year, plainDate.month - 1, plainDate.day);
      jsDate.setHours(0, 0, 0, 0);
      return dayjs().diff(jsDate, 'days');
    },
    localDateTime(value) {
      let d = new Date(value);
      d = dayjs(new Date(d.getTime() + d.getTimezoneOffset() * 60000));
      return `${d.format('l LT')}`;
    },
    dateWithTime(value) {
      const date = dayjs(value);
      return `${date.format('l LT')}`;
    },
    date(value) {
      const date = dayjs(value);
      return `${date.format('l')}`;
    },
    getFormatedDateZone(value) {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return dayjs.utc(value).tz(userTimeZone).format('MM/DD/YYYY LT');
    }
  }
};

export { dateMixin as default };
